import { useCallback } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { DateInput } from 'foundations-components/transitional/components/DateInput';
import { TimeInput } from 'foundations-components/transitional/components/TimeInput';
import * as SimpleDate from 'foundations-components/transitional/utils/SimpleDate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DateAndTimeSelect = ({
  value,
  onChange,
  readOnly = false
}) => {
  const currentMoment = I18n.moment(value || new Date()).tz(I18n.moment.portalTz().tz() || 'UTC');
  const currentMinutes = currentMoment.hours() * 60 + currentMoment.minutes();
  const handleDateChange = useCallback(({
    target: {
      value: newValue
    }
  }) => {
    const newDateInMilliseconds = newValue !== null ? currentMoment.set({
      year: newValue.year,
      month: newValue.month,
      date: newValue.date
    }).valueOf() : null;
    onChange(newDateInMilliseconds);
  }, [currentMoment, onChange]);
  const handleTimeChange = useCallback(({
    target: {
      value: minutes
    }
  }) => {
    const newDateInMilliseconds = currentMoment.set({
      hour: 0,
      minute: minutes,
      second: 0,
      millisecond: 0
    }).valueOf();
    onChange(newDateInMilliseconds);
  }, [currentMoment, onChange]);
  const now = SimpleDate.now();
  const currentDate = value && SimpleDate.fromMoment(currentMoment);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      marginBlockStart: "400",
      marginInlineStart: "400",
      children: [/*#__PURE__*/_jsx(FormLabel, {
        paddingBlockStart: "0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformSettings.scheduledDisableAt.dateLabel"
        })
      }), /*#__PURE__*/_jsx(DateInput, {
        value: currentDate || undefined,
        minValue: now,
        onChange: handleDateChange,
        readOnly: readOnly,
        inputWidth: 350
      }), /*#__PURE__*/_jsx(FormLabel, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformSettings.scheduledDisableAt.timeLabel"
        })
      }), /*#__PURE__*/_jsx(TimeInput, {
        value: value ? currentMinutes : undefined,
        onChange: handleTimeChange,
        readOnly: readOnly,
        format: `LT [${I18n.moment.portalTz().format('z')}]`,
        interval: 30,
        inputWidth: 350
      })]
    })
  });
};
export default DateAndTimeSelect;